'use client';

import * as Sentry from '@sentry/nextjs';
import { useEffect } from 'react';

export default function GlobalError({ error }: { error: Error & { digest?: string } }) {
  useEffect(() => {
    Sentry.captureException(error);
  }, [error]);

  return (
    <html>
      <body>
        <h1>Произошла критическая ошибка. Приложение прекратило работу.</h1>
        <p>Мы уже уведомлены об этом. Пожалуйста, попробуйте обновить страницу.</p>
        <button onClick={() => window.location.reload()}>Обновить страницу</button>
      </body>
    </html>
  );
}
